import { Component, Input } from '@angular/core'
import { SpinnerComponent } from '@spartacus/storefront'

@Component({
    selector: 'eb-spinner',
    templateUrl: './eb-spinner.component.html',
    styleUrls: ['./eb-spinner.component.scss'],
    standalone: false
})
export class EbSpinnerComponent extends SpinnerComponent {
  @Input() size = 3
  @Input() padding = 0
  @Input() width: number | string
  @Input() alignment = 'left'
  @Input() isSearchBoxSpinner = false
}
